import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 text-center text-xs py-8 px-4" data-id="element-55">
      <p className="text-white font-bold text-sm mb-1" data-id="element-56">📚 PACK DE INGLÉS 360</p>
      <p className="mb-3" data-id="element-57">
        El sistema de planificación N°1 para docentes de inglés de primaria y
        secundaria en Argentina.
      </p>
      <p data-id="element-58">
        Porque enseñar inglés no debería costarte todos los domingos del año.
      </p>
      <p className="mt-4" data-id="element-59">
        © PACK DE INGLÉS 360 — Todos los derechos reservados
      </p>
    </footer>;
}